// The feed's Fresh start recommendation (docs/design/fresh-start.md): when a lot of older mail
// sits in the inbox, one quiet banner offers Fresh start before the owner wades through it.
// "Not now" quiets it on this device for a week (a per-device convenience in localStorage; the
// server decides whether there is a reason to show it at all). Never "overdue", never a scoreboard.

/** localStorage key: when "Not now" was last pressed (ISO-8601). */
export const NUDGE_DISMISS_KEY = "meemail.freshStartNudge.dismissedAt";

/** "Not now" keeps the banner away this long. */
export const NUDGE_QUIET_MS = 7 * 86_400_000;

export function freshStartNudgeWords(count: number): string {
  const n = Math.max(0, Math.round(count));
  const one = n === 1;
  const threads = `${n.toLocaleString("en-US")} ${one ? "thread" : "threads"}`;
  const them = one ? "it" : "them";
  return (
    `${threads} older than a month ${one ? "is" : "are"} in your inbox. ` +
    `Fresh start archives ${them} before ${one ? "it becomes a card" : "they become cards"}. ` +
    `You can put ${them} back for 7 days.`
  );
}

/** Whether a "Not now" pressed at `dismissedAt` still holds at `now`. */
export function isNudgeDismissed(dismissedAt: string | null, now: number): boolean {
  if (!dismissedAt) return false;
  const at = Date.parse(dismissedAt);
  if (!Number.isFinite(at)) return false;
  return now - at < NUDGE_QUIET_MS;
}

function storage(): Storage | null {
  try {
    return typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return null;
  }
}

export function readNudgeDismissedAt(store: Storage | null = storage()): string | null {
  try {
    return store?.getItem(NUDGE_DISMISS_KEY) ?? null;
  } catch {
    return null;
  }
}

export function recordNudgeDismissed(now: number, store: Storage | null = storage()): void {
  try {
    store?.setItem(NUDGE_DISMISS_KEY, new Date(now).toISOString());
  } catch {
    // Blocked or full storage: the banner just comes back next time.
  }
}
